import React from "react";
import styles from "./LineSeparator.module.scss";

const LineSeparator = () => {
  return <div className={styles.lineSeparator}></div>;
};

export default LineSeparator;
